import { useEffect, useState } from 'react';
import { ArrowUpRight, BellRing, X } from 'lucide-react';
import { api } from '../lib/api';
import { useToast } from '../context/ToastContext';

interface DiscordConfig { enabled: boolean; installUrl: string | null }

const ACTIVE_KEY = 'gangacars:discord-alerts-active';

export function DiscordAlertPrompt() {
  const { notify } = useToast();
  const [subscribed, setSubscribed] = useState(() => localStorage.getItem(ACTIVE_KEY) === 'true');
  const [installUrl, setInstallUrl] = useState<string | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const url = new URL(window.location.href);
    const status = url.searchParams.get('discord');
    if (!status) return;
    url.searchParams.delete('discord');
    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    if (status !== 'activated') return;
    localStorage.setItem(ACTIVE_KEY, 'true');
    setSubscribed(true);
    notify('Recibirás por mensaje privado cada nueva edición con la selección Clase A.', 'discord');
  }, [notify]);

  useEffect(() => {
    if (subscribed) return;
    let showTimer = 0;
    let hideTimer = 0;
    let cancelled = false;
    api<DiscordConfig>('/api/discord/config').then((config) => {
      if (cancelled || !config.enabled || !config.installUrl) return;
      setInstallUrl(config.installUrl);
      showTimer = window.setTimeout(() => {
        setVisible(true);
        hideTimer = window.setTimeout(() => setVisible(false), 9000);
      }, 1200);
    }).catch(() => undefined);
    return () => {
      cancelled = true;
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, [subscribed]);

  if (!visible || !installUrl || subscribed) return null;

  return (
    <aside className="gc-discord-prompt fixed bottom-4 left-1/2 z-[90] w-[min(46rem,calc(100vw-2rem))] -translate-x-1/2 overflow-hidden rounded-[1.1rem_.4rem_1.1rem_.4rem] border border-gangacars-yellow/60 bg-[#111417]/95 shadow-[0_24px_80px_rgba(0,0,0,.72)] backdrop-blur-xl" aria-label="Boletín de GangaCars">
      <div className="flex flex-col gap-4 p-4 pr-12 sm:flex-row sm:items-center sm:p-5 sm:pr-12">
        <div className="flex min-w-0 flex-1 items-start gap-4">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-gangacars-yellow text-black shadow-[0_0_24px_rgba(250,204,21,.25)]"><BellRing size={21} /></div>
          <div className="min-w-0"><span className="text-[10px] font-extrabold uppercase tracking-[.18em] text-gangacars-yellow">Boletín GangaCars · Puerta del Sol</span><h2 className="mt-0.5 font-display text-lg uppercase leading-tight text-white">Las novedades Clase A, directamente para ti</h2><p className="mt-1 text-xs leading-5 text-slate-400">Suscríbete al boletín privado y conoce cada nueva selección de vehículos destacados.</p></div>
        </div>
        <a href={installUrl} className="btn-primary w-full shrink-0 sm:w-auto">Suscribirme <ArrowUpRight size={17} /></a>
      </div>
      <button type="button" className="absolute right-3 top-3 rounded-md p-1.5 text-slate-500 transition hover:bg-white/5 hover:text-white" onClick={() => setVisible(false)} aria-label="Cerrar aviso"><X size={17} /></button>
      <div className="gc-discord-prompt-timer h-0.5 origin-left bg-gradient-to-r from-gangacars-yellow via-gangacars-orange to-red-500" />
    </aside>
  );
}
